import * as React from 'react';

import { MyGroupsPage } from '@/components/MyGroupsPage/MyGroupsPage';
import { RouteRestrictions } from '@/utilities';
import { restrictedRoute } from '@/utilities/restrictedRoute';

export default restrictedRoute(MyGroupsPage, {
  requiresEvery: [RouteRestrictions.COMMUNITY_ACCESS],
});







